if (!customElements.get('studio-bundle')) {
  customElements.define('studio-bundle', class extends HTMLElement {
    connectedCallback() {
      this.count = 1;
      this.onChange = () => this.update();
      this.addEventListener('change', this.onChange);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (data.sectionId !== this.dataset.section || !data.variant) return;
        const select = this.querySelector('select');
        if ([...select.options].some(option => option.value === String(data.variant.id))) {
          select.value = String(data.variant.id);
          this.update();
        }
      });
      this.update();
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.unsubscribe?.();
    }
    update() {
      this.count = Number(this.querySelector('input:checked')?.value || 1);
      this.querySelector('.studio-bundle__variants').hidden = this.count === 1;
      let total = 0;
      this.querySelectorAll('[data-bundle-row]').forEach((row, index) => {
        row.hidden = index >= this.count;
        const select = row.querySelector('select');
        select.disabled = index >= this.count;
        if (index < this.count) total += Number(select.selectedOptions[0]?.dataset.price || 0);
      });
      this.querySelector('[data-bundle-total]').textContent = new Intl.NumberFormat('nl-NL', {style:'currency', currency:this.dataset.currency || 'EUR'}).format(total / 100);
      const quantity = this.closest('product-info')?.querySelector('[id^="Quantity-Form-"]');
      if (quantity) quantity.hidden = this.count > 1;
      const expressCheckout = this.closest('product-info')?.querySelector('.shopify-payment-button');
      if (expressCheckout) expressCheckout.hidden = this.count > 1;
    }
    getItems() {
      if (this.count === 1) return null;
      const items = [...this.querySelectorAll('[data-bundle-row] select')].slice(0, this.count).map(select => ({id:select.value, quantity:1}));
      return items.every(item => /^\d+$/.test(item.id)) ? items : null;
    }
  });
}
if (!customElements.get('studio-newsletter')) {
  customElements.define('studio-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.key = `studio-newsletter-${this.dataset.section}`;
      this.close = () => this.dialog.close();
      this.querySelector('[data-close]').addEventListener('click', this.close);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.close(); });
      this.show = () => { if (!this.dialog.open) this.dialog.showModal(); };
      this.editorSelect = event => { if (event.detail.sectionId === this.dataset.section) this.show(); };
      if (this.hasAttribute('data-editor')) {
        document.addEventListener('shopify:section:select', this.editorSelect);
        return;
      }
      let dismissed = false;
      try { dismissed = sessionStorage.getItem(this.key) === 'shown'; } catch (_) { /* storage is optional */ }
      if (!dismissed) this.timer = setTimeout(() => {
        if (document.querySelector('cart-drawer.active, menu-drawer details[open], quick-add-modal[open]')) return;
        this.show();
        try { sessionStorage.setItem(this.key, 'shown'); } catch (_) { /* keep form usable without storage */ }
      }, Number(this.dataset.delay) * 1000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('shopify:section:select', this.editorSelect);
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
